import type { SVGProps } from 'react';
const DawnFlagHR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-HR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-HR_svg__a)">
      <path fill="#FF202D" d="M0 5.333h22V0H0z" />
      <path
        fill="#1895DB"
        d="m8.38 4.267.525-.534.523.534v1.066H8.381zm2.096 0L11 3.733l.524.534v1.066h-1.048zm2.62-.534-.525.534v1.066h1.048V4.267z"
        opacity={0.5}
      />
      <path
        fill="#191F94"
        d="m9.953 3.733-.524.534v1.066h1.047V4.267zm2.095 0-.524.534v1.066h1.048V4.267z"
        opacity={0.5}
      />
      <path fill="#2027AC" d="M0 16h22v-5.333H0z" />
      <path
        fill="url(#dawn-flag-HR_svg__b)"
        d="M9.428 5.333h-.523L8.38 6.4h1.047zm1.048 0h1.048V6.4h-1.048zm0 2.134V6.4H9.428v1.067H8.381v1.066h1.047V9.6H8.381v1.067h1.047v1.066h1.048v-1.066h1.048v1.066h1.047v-1.066h1.048V9.6h-1.048V8.533h1.048V7.467h-1.048V6.4h1.048l-.524-1.067h-.524V6.4h-1.047v1.067zm0 1.066H9.428V7.467h1.048zm1.048 0h-1.048V9.6H9.428v1.067h1.048V9.6h1.048v1.067h1.047V9.6h-1.047zm0 0h1.047V7.467h-1.047z"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-HR_svg__b"
        x1={8.381}
        x2={8.381}
        y1={5.333}
        y2={11.733}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF212E" />
        <stop offset={1} stopColor="#FD0D1B" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagHR;
